/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from 'prop-types';
import {
  Button,
  makeStyles,
  InputAdornment,
  OutlinedInput,
  InputLabel,
  FormControl,
  IconButton,
  Grid,
  FormHelperText,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { useHistory } from 'react-router-dom'; // Import de useHistory pour v5
import { userServices } from '../../../redux/services/userServices';
import Login from '../index'; // Import du composant Login

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  dialogContent: {
    padding: 20,
    minWidth: '400px',
    zIndex: 2, // Positionne la pop-up au-dessus du contenu arrière-plan
  },
  dialogBackdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1, // Définit l'arrière-plan sous la pop-up
  },
}));

const isValidPassword = (password) => {
  // Minimum eight characters, at least one letter and one number
  const regex = new RegExp('^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$');
  return regex.test(password);
};

const NewForgotPasswordForm = ({ token }) => {
  const classes = useStyles();
  const history = useHistory(); // Hook pour la redirection avec useHistory

  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [showPass1, setShowPass1] = useState(false);
  const [showPass2, setShowPass2] = useState(false);
  const [creatingNewPassword, setCreatingNewPassword] = useState(false);
  const [newPasswordCreated, setNewPasswordCreated] = useState(false);
  const [openDialog, setOpenDialog] = useState(true);

  const changeShowPass1 = () => {
    setShowPass1(!showPass1);
  };

  const changeShowPass2 = () => {
    setShowPass2(!showPass2);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClick = (e) => {
    e.preventDefault();
    setCreatingNewPassword(true);
    const newPassword = {
      password: password1,
      token,
    };
    userServices.sendNewPassword(newPassword)
      .then(() => {
        toast.success('Votre mot de passe a été modifié avec succès');
        setCreatingNewPassword(false);
        setNewPasswordCreated(true);

        // Rediriger l'utilisateur vers la page de login après la réussite de la modification
        setTimeout(() => {
          history.push('/login'); // Remplace '/login' par l'URL de la page de login
        }, 2000); // Délai pour afficher le message de succès
      })
      .catch(() => {
        toast.error('Une erreur est survenue lors de la modification de votre mot de passe');
        setCreatingNewPassword(false);
        setNewPasswordCreated(false);
      });
  };

  return (
    <div>
      {/* Affichage du composant Login en arrière-plan */}
      <div className={classes.dialogBackdrop}>
        <Login />
      </div>

      {/* La pop-up s'affiche automatiquement */}
      <Dialog open={openDialog} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Réinitialiser votre mot de passe</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <form className={classes.form} noValidate>
            <Grid item>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="password">Mot de passe</InputLabel>
                <OutlinedInput
                  error={password1 && !isValidPassword(password1)}
                  type={showPass1 ? 'text' : 'password'}
                  margin="normal"
                  required
                  name="password1"
                  label="Mot de passe"
                  id="password1"
                  autoComplete="new-password"
                  value={password1}
                  onChange={(e) => setPassword1(e.target.value)}
                  endAdornment={(
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={changeShowPass1}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPass1 ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )}
                />
                {password1 && !isValidPassword(password1) && (
                  <FormHelperText error id="password-error">
                    Merci de créer un mot de passe avec au moins 8 caractères,
                    une majuscule et un chiffre.
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item style={{ marginTop: '3%' }}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="password">Confirmer mot de passe</InputLabel>
                <OutlinedInput
                  error={!(password1 === password2)}
                  margin="normal"
                  type={showPass2 ? 'text' : 'password'}
                  required
                  name="password2"
                  label="Confirmer mot de passe"
                  id="password2"
                  autoComplete="new-password"
                  value={password2}
                  onChange={(e) => setPassword2(e.target.value)}
                  endAdornment={(
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={changeShowPass2}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPass2 ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )}
                />
              </FormControl>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              onClick={(e) => handleClick(e)}
              style={{ marginTop: '3%' }}
              disabled={!(password1 === password2) || !isValidPassword(password1) || creatingNewPassword || newPasswordCreated}
            >
              {creatingNewPassword
                ? 'Création en cours'
                : newPasswordCreated
                  ? 'Votre mot de passe a été modifié'
                  : 'Créer un nouveau mot de passe'}
            </Button>
          </form>
        </DialogContent>
      </Dialog>

      <ToastContainer
        position="top-left"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
      />
    </div>
  );
};

NewForgotPasswordForm.propTypes = {
  token: PropTypes.string.isRequired,
};

export default NewForgotPasswordForm;
